import * as React from 'react';

import styles from './ConnectionPage.scss';
import { ConnectionPageLocale } from './connectionPage.locale';
import Header from '../Header/Header';
import Cta from '../Cta/Cta';
import LinkButton from '../Button/LinkButton';
import List from '../List/List';
import headerBg from './headerBg.svg';

interface ConnectionPageProps {
  locale: ConnectionPageLocale;
}

const ConnectionPage: React.SFC<ConnectionPageProps> = ({ locale }) => (
  <>
    <Header
      title={locale.title}
      subtitle={locale.subtitle}
      backgroundImage={headerBg}
      backgroundPosition="center 50%"
      backgroundSize="auto 190%"
    />
    <main>
      <section className="container py-7 py-md-8">
        <div className="row">
          <div className="col-12 col-md">
            <h3 className={styles.sectionTitle}>{locale.requirements.title}</h3>
            <List items={locale.requirements.list} />
            <div
              className={styles.requirementsPostscript}
              dangerouslySetInnerHTML={{ __html: locale.requirements.postscript }}
            />
          </div>
          <div className="col-12 col-md">
            <h3 className={styles.sectionTitle}>{locale.process.title}</h3>
            <List
              items={locale.process.steps.map((step, index) => (
                <span key={index} dangerouslySetInnerHTML={{ __html: step }} />
              ))}
              ordered
            />
          </div>
        </div>
      </section>
      <Cta title={locale.cta.title} backgroundType="circles">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-sm-0">
            <LinkButton to={locale.cta.primaryButton.href}>
              {locale.cta.primaryButton.text}
            </LinkButton>
          </div>
          <div className="col-auto">
            <LinkButton to={locale.cta.secondaryButton.href} secondary>
              {locale.cta.secondaryButton.text}
            </LinkButton>
          </div>
        </div>
      </Cta>
    </main>
  </>
);

export default ConnectionPage;



// WEBPACK FOOTER //
// /www/client/src/components/ConnectionPage/ConnectionPage.tsx